import produce from "immer";
import { createAsyncAction } from "typesafe-actions";
import { ActionType, createReducer } from "typesafe-actions";
import { Announcements } from "../../../Types/UnitFeatureTypes";


export interface FetchAnnouncementInfoState {
  request: {
      loading: boolean;
      error: string | null;
      singleAnnouncement: Announcements | null;
      data: Announcements[] | null;
      count: string | null;
  };
}

export enum Types {
  FETCH_ANNOUNCEMENT_REQUEST = "FETCH_ANNOUNCEMENT_REQUEST",
  FETCH_ANNOUNCEMENT_SUCCESS = "FETCH_ANNOUNCEMENT_SUCCESS",
  FETCH_ANNOUNCEMENT_FAILURE = "FETCH_ANNOUNCEMENT_FAILURE",
}

const announcementActions = createAsyncAction(
  Types.FETCH_ANNOUNCEMENT_REQUEST,
  Types.FETCH_ANNOUNCEMENT_SUCCESS,
  Types.FETCH_ANNOUNCEMENT_FAILURE,
)
<
  { id?: string, offset?: number, sortColumn?: string, sortDirection?: string },
  { announcements?: Announcements[], announcement?: Announcements, count: string },
  { message: string }
>();

export const Actions = { announcementActions };

export const initialState: FetchAnnouncementInfoState = {
  request: {
    loading: false,
    error: null as string | null,
    singleAnnouncement: null,
    data: null,
    count: '0'
  }
};

export type FetchAnnouncementState = typeof initialState;

const fetchAnnouncementRequest = (state = initialState) =>
  produce(state, (draft) => {
    draft.request.loading = true;
    draft.request.error = null;
    draft.request.data = null;

    return draft;
  });

const fetchAnnouncementSuccess = (
  state = initialState,
  { payload }: ActionType<typeof Actions.announcementActions.success>
) =>
  produce(state, (draft) => {
    draft.request.error = null;
    draft.request.data = payload.announcements ?? null;
    draft.request.singleAnnouncement = payload.announcement ?? null;
    draft.request.count = payload.count;
    if (draft.request.data) {
      draft.request.loading = false;
    }

    return draft;
  });

const fetchAnnouncementFailure = (
  state = initialState,
  { payload }: ActionType<typeof Actions.announcementActions.failure>
) =>
  produce(state, (draft) => {
    draft.request.loading = false;
    draft.request.error = payload.message;

    return draft;
  });


export default createReducer<typeof initialState, ActionType<typeof Actions>>(
  initialState
)
  .handleAction(Actions.announcementActions.request, fetchAnnouncementRequest)
  .handleAction(Actions.announcementActions.success, fetchAnnouncementSuccess)
  .handleAction(Actions.announcementActions.failure, fetchAnnouncementFailure);
  